import ToastHelper from "utils/ToastHelper";
import UtilityService from "../UtilityService";

export default class UtilityCountryList {

    static COUNTRY_LIST = null;
    static COUNTRY_LIST_LOADING = false;
    static COUNTRY_LIST_CALLBACKS = [];

    static retrieveCountryList(callback) {

        if (UtilityCountryList.COUNTRY_LIST !== null) {
            if (callback) {
                callback(UtilityCountryList.COUNTRY_LIST);
            }
        } else {
            if (callback) {
                UtilityCountryList.COUNTRY_LIST_CALLBACKS.push(callback);
            }

            if (!this.COUNTRY_LIST_LOADING) {
                this.COUNTRY_LIST_LOADING = true;
                this.fetchList();
            }
        }
    }

    static fetchList(retryCount = 2) {
        UtilityService.retrieveCountryList().then(response => {
            if (Array.isArray(response)) {
                UtilityCountryList.COUNTRY_LIST = response;

                this.COUNTRY_LIST_CALLBACKS.forEach(countryListCallback => {
                    countryListCallback(UtilityCountryList.COUNTRY_LIST);
                });
                this.COUNTRY_LIST_CALLBACKS = [];

            } else {
                if (retryCount > 0) {
                    setTimeout(() => {
                        this.fetchList(retryCount - 1);
                    }, 500);
                } else {
                    ToastHelper.formatError("Failed to load country list");
                }
            }
            UtilityCountryList.COUNTRY_LIST_LOADING = false;

        });
    }
}
